import ListingInformationHeader from './ListingInformationHeader.component';

export default ListingInformationHeader;
